// 章节版本配额管理：自动保存单独分列（50 个），手动/AI 等其他操作共用（50 个），
// 各分组超限时只删除该分组最老的版本，绝不误删其他来源的版本。
import { MAX_AUTO_SAVE_VERSIONS, MAX_MANUAL_VERSIONS } from '../types';

/** 在创建新版本前调用：确保对应来源分组有足够配额（删除该组最老的超限版本） */
export async function ensureVersionQuota(chapterId: string, source: string): Promise<void> {
  const isAuto = source === 'auto_save';
  const cap = isAuto ? MAX_AUTO_SAVE_VERSIONS : MAX_MANUAL_VERSIONS;
  const filter = isAuto ? { source: 'auto_save' } : { notSource: 'auto_save' };
  try {
    const count = await window.api.getChapterVersionCount(chapterId, filter);
    if (count >= cap) {
      await window.api.deleteOldestVersions(chapterId, cap - 1, filter);
    }
  } catch {
    // 配额清理失败不阻断版本保存
  }
}
